document.addEventListener('DOMContentLoaded', function () {
  const collectionCategories = document.querySelector('.collection-categories');
  const collectionCategoriesContainer = document.querySelector('.collection-categories-container');
  const collectionCategoriesPrev = document.querySelector(
    '.collection-categories-container .prev-next-button--prev'
  );
  const collectionCategoriesNext = document.querySelector(
    '.collection-categories-container .prev-next-button--next'
  );

  if (!collectionCategories || !collectionCategoriesPrev || !collectionCategoriesNext) {
    return;
  }

  function updateButtonStates() {
    const scrollLeft = collectionCategories.scrollLeft;
    const scrollWidth = collectionCategories.scrollWidth;
    const clientWidth = collectionCategories.clientWidth;

    // Add/remove disabled class for prev button if at start
    if (scrollLeft <= 0) {
      collectionCategoriesPrev.classList.add('is-disabled');
    } else {
      collectionCategoriesPrev.classList.remove('is-disabled');
    }

    // Add/remove disabled class for next button if at end (with small tolerance for rounding)
    if (scrollLeft + clientWidth >= scrollWidth - 1) {
      collectionCategoriesNext.classList.add('is-disabled');
    } else {
      collectionCategoriesNext.classList.remove('is-disabled');
    }
  }

  function scrollCarousel(direction) {
    const items = Array.from(collectionCategories.querySelectorAll('a'));
    if (items.length === 0) return;

    const currentScroll = collectionCategories.scrollLeft;
    const containerWidth = collectionCategories.clientWidth;
    const scrollOffset = 50; // Offset to account for arrows and spacing
    let targetScroll = 0;

    // Find which item is currently closest to the scroll position
    let currentItemIndex = 0;
    let minDistance = Math.abs(items[0].offsetLeft - (currentScroll + scrollOffset));

    for (let i = 1; i < items.length; i++) {
      const distance = Math.abs(items[i].offsetLeft - (currentScroll + scrollOffset));
      if (distance < minDistance) {
        minDistance = distance;
        currentItemIndex = i;
      }
    }

    if (direction === 'next') {
      // Scroll to the next item
      if (currentItemIndex < items.length - 1) {
        targetScroll = Math.max(0, items[currentItemIndex + 1].offsetLeft - scrollOffset);
      } else {
        // At the last item, scroll to the end
        targetScroll = collectionCategories.scrollWidth - containerWidth;
      }
    } else {
      // Scroll to the previous item
      if (currentItemIndex > 0) {
        targetScroll = Math.max(0, items[currentItemIndex - 1].offsetLeft - scrollOffset);
      } else {
        // At the first item, scroll to start
        targetScroll = 0;
      }
    }

    collectionCategories.scrollTo({
      left: targetScroll,
      behavior: 'smooth',
    });
  }

  // Handle button clicks
  collectionCategoriesPrev.addEventListener('click', function () {
    if (!this.classList.contains('is-disabled')) {
      scrollCarousel('prev');
    }
  });

  collectionCategoriesNext.addEventListener('click', function () {
    if (!this.classList.contains('is-disabled')) {
      scrollCarousel('next');
    }
  });

  // Update button states on scroll
  collectionCategories.addEventListener('scroll', updateButtonStates);

  // Recalculate on resize
  let resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      updateButtonStates();
    }, 100);
  });

  // Initial button state
  updateButtonStates();
});
